import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Category from "../../../Assets/Icon/icon/01.png";
import Following from "../../../Assets/Icon/icon/02.png";
import FanGroup from "../../../Assets/Icon/icon/03.png";
import Package from "../../../Assets/Icon/icon/04.png";
import EnrolledAuditions from "../../../Assets/Icon/icon/05.png";
import Activities from "../../../Assets/Icon/icon/06.png";
import Setting from "../../../Assets/Icon/icon/07.png";
import Policy from "../../../Assets/Icon/icon/10.png";
import Sub1 from "../../../Assets/Icon/icon/01s.png";
import Sub2 from "../../../Assets/Icon/icon/02s.png";
import Sub3 from "../../../Assets/Icon/icon/03s.png";
import Sub4 from "../../../Assets/Icon/icon/04s.png";
import Sub5 from "../../../Assets/Icon/icon/05s.png";
import Sub6 from "../../../Assets/Icon/icon/06s.png";

import axios from "axios";

const SmallSideMenu = () => {
  const [activity, setCountActivity] = useState(0);
  const [pendingAudition, setPendingAudition] = useState();
  const [fanCount, setFanCount] = useState();
  const [categoryCount, setCategoryCount] = useState();
  const [starCategoryCount, setStarCategoryCount] = useState();
  const [wallet, setWallet] = useState();

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get("api/user/activity_count").then((res) => {
        if (res.data.status === 200) {
          setCountActivity(res.data.activity);
        }
      });

    localStorage.getItem("auth_token") &&
      axios.get("api/user/pendingEnrollAudition").then((res) => {
        if (res.data.status === 200) {
          setPendingAudition(res.data.enrolledAuditionsPending);
        }
      });

    localStorage.getItem("auth_token") &&
      axios.get(`/api/user/fan/group/list`).then((res) => {
        if (res.data.status === 200) {
          setFanCount(res.data.fanCount);
        }
      });

    axios.get(`/api/all/sidebar/list`).then((res) => {
      if (res.data.status === 200) {
        setCategoryCount(res.data.categoryCount);
        setStarCategoryCount(res.data.starCategoryCount);
        setWallet(res.data.wallet);
      }
    });
  }, []);

  return (
    <>
      <div className="col-6 col-md-4 px-2 py-1 ">
        <Link to="/category">
          <div className="d-flex btn CatBlock align-items-center">
            <div className="text-warning col-md-3">
              <img src={Category} alt="" className="icon-sm-d mx-2" />
            </div>
            <div className="Cat-Title col-9">
              Category <br />
              <small className="category-size-chat">
                {" "}
                {categoryCount ? categoryCount : 0} Selected
              </small>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-6 col-md-4 px-2 py-1">
        <Link to="/following">
          <div className="d-flex btn CatBlock align-items-center">
            <div className="text-warning col-md-3">
              <img src={Following} alt="" className="icon-sm-d mx-2" />
            </div>
            <div className="Cat-Title col-9">
              Following <br />
              <small className="category-size-chat">
                {" "}
                {starCategoryCount ? starCategoryCount : 0} Superstar
              </small>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-6 col-md-4 px-2 py-1">
        <Link to="/fan-group">
          <div className="d-flex btn CatBlock align-items-center">
            <div className="text-warning col-md-3">
              <img src={FanGroup} alt="" className="icon-sm-d mx-2" />
            </div>
            <div className="Cat-Title col-9">
              Fan Group <br />
              <small className="category-size-chat"> {fanCount} group</small>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-6 col-md-4 px-2 py-1">
        <Link to="/wallet">
          <div className="d-flex btn CatBlock align-items-center">
            <div className="text-warning col-md-3">
              <img src={Package} alt="" className="icon-sm-d mx-2" />
            </div>
            <div className="Cat-Title col-9">
              Package <br />
              <small className="category-size-chat">200 Star</small>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-6 col-md-4 px-2 py-1">
        <Link to="/enrolled-auditions">
          <div className="d-flex btn CatBlock align-items-center">
            <div className="text-warning col-md-3">
              <img src={EnrolledAuditions} alt="" className="icon-sm-d mx-2" />
            </div>
            <div className="Cat-Title col-9">
              Enrolled audition <br />
              <small className="category-size-chat">
                {pendingAudition} Pending
              </small>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-6 col-md-4 px-2 py-1">
        <Link to="/activities">
          <div className="d-flex btn CatBlock align-items-center">
            <div className="text-warning col-md-3">
              <img src={Activities} alt="" className="icon-sm-d mx-2" />
            </div>
            <div className="Cat-Title col-9">
              Activities <br />
              <small className="category-size-chat">
                {activity} Activities recently
              </small>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-6 col-md-4 px-2 py-1">
        <Link to="/settings">
          <div className="d-flex btn CatBlock align-items-center align-items-center">
            <div className="text-warning col-md-3">
              <img src={Setting} alt="" className="icon-sm-d mx-2" />
            </div>
            <div className="Cat-Title col-9">Setting</div>
          </div>
        </Link>
      </div>

      <div className="col-6 col-md-4 px-2 py-1">
        <div className=" accordion accordion-flush" id="accordionFlushExample">
          <div className=" core-small-x accordion-item">
            <h2
              className="core-small-x  accordion-header "
              id="flush-headingOne"
            >
              <div
                className="d-flex btn CatBlock align-items-center align-items-center core-small-x"
                t
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                <div className="text-warning col-md-3">
                  <img src={Policy} alt="" className="icon-sm-d mx-2" />
                </div>
                <div className="Cat-Title col-9">Terms & Policy</div>
              </div>
            </h2>
            <div
              id="flush-collapseOne"
              className="core-small core-small-p accordion-collapse collapse "
              aria-labelledby="flush-headingOne"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="d-flex align-items-center core-small-xy px-3 py-1 ">
                <Link to="/about-us">
                  <img src={Sub1} alt="" className="me-2" />
                  <small className="sub-policy-x">About Us</small>
                </Link>
              </div>

              <div className="d-flex align-items-center core-small-xy px-3 py-1 ">
                <Link to="/privacy-policy">
                  <img src={Sub2} alt="" className="me-2" />
                  <small className="sub-policy-x">Privacy Policy</small>
                </Link>
              </div>

              <div className="d-flex align-items-center core-small-xy px-3 py-1 ">
                <Link to="/product-purchase-flow">
                  <img src={Sub3} alt="" className="me-2" />
                  <small className="sub-policy-x">Product Purchase Flow</small>
                </Link>
              </div>

              <div className="d-flex align-items-center core-small-xy px-3 py-1 ">
                <Link to="/terms-condition">
                  <img src={Sub4} alt="" className="me-2" />
                  <small className="sub-policy-x">Terms & Condition</small>
                </Link>
              </div>

              <div className="d-flex align-items-center core-small-xy px-3 py-1 ">
                <Link to="/refund-return-policy">
                  <img src={Sub5} alt="" className="me-2" />
                  <small className="sub-policy-x">
                    Refund , Return & Policy
                  </small>
                </Link>
              </div>

              <div className="d-flex align-items-center core-small-xy px-3 py-1">
                <Link to="/faq">
                  <img src={Sub6} alt="" className="me-2" />
                  <small className="sub-policy-x">FAQ</small>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SmallSideMenu;
